export type SvgProps = Readonly<{
  src: string;
  color?: string;
  className?: string;
}>;

const style = {
  imageArea: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    height: 'fit-content',
  },
  image: (display: boolean) => display ? {} : { opacity: 0 },
  colorFilter: (url: string, color: string) => ({
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    maskImage: `url(${url})`,
    maskSize: 'contain',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    backgroundColor: color,
  }),
};

const Svg = (props: SvgProps) => (
  <div css={style.imageArea}>
    <img src={props.src} css={style.image(!props.color)} className={props.className} />
    {props.color && (
      <div css={style.colorFilter(props.src, props.color)}></div>
    )}
  </div>
);

export default Svg;
